<nav class="px-6 container mx-auto">
  <div class="flex flex-wrap justify-between mx-auto p-4">
    <button
      type="button"
      class="focus:outline-none"
      (click)="navigateToSettings()"
    >
      <img
        src="/assets/others/harmburger.webp"
        class="h-8 w-8"
        alt="Genie Logo"
      />
    </button>
    <a routerLink="/" class="flex items-center space-x-3 rtl:space-x-reverse">
      <img
        src="/assets/others/horizontalLogo.webp"
        class="h-12"
        alt="Genie Logo"
      />
    </a>

    <div class="flex space-x-6">
      @if(image){

      <img
        [src]="image"
        class="w-28 h-14 object-cover rounded-2xl border-4 border-tl-dark-blue shadow-[2px_2px_0px_0px_rgba(137,137,137,1)]"
      />

      }
   <div class="flex items-center gap-3">
    @if(isCorteva){
         <a
    routerLink="../genie/corteva-database"
    class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit self-center text-white font-semibold rounded-[1.5rem] px-6 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50"
    >Database</a
  >
    }
       <button type="button" class="focus:outline-none" (click)="logout()">
        <img
          src="/assets/others/logoutIcon.webp"
          class="h-8 w-8"
          alt="Genie Logo"
        />
      </button>
   </div>
    </div>
  </div>
</nav>

<div class="min-h-screen">
  <router-outlet></router-outlet>
</div>
